module.exports = __webpack_public_path__ + "img/Cuban Bowl-Tofu.8202af83.jpg";